const MEDALS = ["🥇", "🥈", "🥉"];

export default function Victory({ players, onNewGame }) {
  const winner = players.find((p) => p.eliminatedAt === null);
  const eliminated = players
    .filter((p) => p.eliminatedAt !== null)
    .sort((a, b) => b.eliminatedAt - a.eliminatedAt);

  const ranked = [winner, ...eliminated].filter(Boolean);

  const getQuote = (p, index) => {
    if (index === 0) return p.config.win_say?.[0] ?? null;
    if (index === 1) return p.config.win_say?.[1] ?? null;
    if (index === 2) return p.config.win_say?.[2] ?? null;
    return p.config.lose_say ?? null;
  };

  return (
    <div className="Victory">
      <div className="Victory-Title">Итоги игры</div>
      <div className="Victory-List">
        {ranked.map((p, index) => (
          <div
            key={p.id}
            className={"Victory-Card" + (index === 0 ? " Victory-Card--first" : "")}
          >
            <div className="Victory-Medal">{MEDALS[index] ?? index + 1}</div>
            <img className="Victory-Avatar" src={p.config.image_url} alt={p.config.name} />
            <div className="Victory-Info">
              <div className="Victory-Name">{p.config.name}</div>
              <div className="Victory-Author">{p.config.author_name}</div>
              {getQuote(p, index) && (
                <div className="Victory-Quote">{getQuote(p, index)}</div>
              )}
            </div>
          </div>
        ))}
      </div>
      <button className="Victory-Btn" onClick={onNewGame}>
        Новая игра
      </button>
    </div>
  );
}
